var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_vm._m(0),_c('home-info'),_c('consignation')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero is-dark"},[_c('div',{staticClass:"hero-body"},[_c('h2',{staticClass:"title is-1"},[_vm._v(" Centro Social Paroquial da Brandoa ")])])])
}]

export { render, staticRenderFns }